<template>
  <svg viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5123 0.266601L8.3123 0.2666C8.92373 0.2666 9.22944 0.986045 8.79801 1.40549L5.39801 4.71105C5.12944 4.97216 4.69516 4.97216 4.42944 4.71105L1.02658 1.40549C0.595155 0.986046 0.900869 0.266602 1.5123 0.266601Z"
      fill="#2582C5"
    />
  </svg>
</template>
